<template>
    <div class="app-header">
        <Navigation></Navigation>
        <SchoolMapHeader/>
    </div>
</template>

<script>
  import Navigation from '@/components/Navigation.vue';
  import SchoolMapHeader from '@/components/SchoolMap/SchoolMapHeader';
  export default {
    name: "app-header",
    components: {
        Navigation,
        SchoolMapHeader
    }
  }
</script>

<style scoped>

</style>
